import axios from 'axios';
import {
	req,
	reqF,
} from './axiosFun';


// 获取产品类型列表分页列表
export const GetProductTypePageList = (params) => {
	return reqF("post", "/api/sysConfig/Product/GetProductTypePageList", params)
};
// 保存产品类型
export const SaveProductType = (params) => {
	return reqF("post", "/api/sysConfig/Product/SaveProductType", params)
};
// 获取产品类型详情
export const GetProductTypeDetail = (params) => {
	return reqF("post", "/api/sysConfig/Product/GetProductTypeDetail", params)
};
// 删除产品类型
export const DeleteProductType = (params) => {
	return reqF("post", "/api/sysConfig/Product/DeleteProductType", params)
};
// 获取产品类型列表
export const GetProductTypeList = (params) => {
	return reqF("post", "/api/sysConfig/Product/GetProductTypeList", params)
};
// 获取产品类型历史记录分页列表
export const GetProductTypeHistoryPageList = (params) => {
	return reqF("post", "/api/sysConfig/Product/GetProductTypeHistoryPageList", params)
};
// 获取产品类型名称列表
export const GetProductTypeNameList = (params) => {
	return reqF("post", "/api/sysConfig/Product/GetProductTypeNameList", params)
};
// 获取产品类型子名称列表
export const GetProductTypeSubNameList = (params) => {
	return reqF("post", "/api/sysConfig/Product/GetProductTypeSubNameList", params)
};


// 获取门店库存分页列表
export const GetStoreProductPageList = (params) => {
	return reqF("post", "/api/sysConfig/Product/GetStoreProductPageList", params)
};
// 批量创建门店库存
export const BatchCreateStoreProduct = (params) => {
	return reqF("post", "/api/sysConfig/Product/BatchCreateStoreProduct", params)
};
// 获取门店库存详情
export const GetStoreProductDetail = (params) => {
	return reqF("post", "/api/sysConfig/Product/GetStoreProductDetail", params)
};
// 根据id列表获取门店库存商品信息列表
export const GetStoreProductList = (params) => {
	return reqF("post", "/api/sysConfig/Product/GetStoreProductList", params)
};
// 修改库存商品数量
export const EditStoreProductQty = (params) => {
	return reqF("post", "/api/sysConfig/Product/EditStoreProductQty", params)
};


// 获取门店库存历史记录分页列表
export const GetStoreProductHistoryPageList = (params) => {
	return reqF("post", "/api/sysConfig/Product/GetStoreProductHistoryPageList", params)
};
// 保存门店入库单
export const SaveInputStoreProduct = (params) => {
	return reqF("post", "/api/sysConfig/Product/SaveInputStoreProduct", params)
};
// 删除门店入库单
export const DeleteInputStoreProduct = (params) => {
	return reqF("post", "/api/sysConfig/Product/DeleteInputStoreProduct", params)
};
// 获取门店入库单详情
export const GetStoreProductHistoryDetail = (params) => {
	return reqF("post", "/api/sysConfig/Product/GetStoreProductHistoryDetail", params)
};
// 确认门店入库单
export const ConfirmStoreProduct = (params) => {
	return reqF("post", "/api/sysConfig/Product/ConfirmStoreProduct", params)
};


// 分页获取调拨记录主表信息
export const GetProductTransferRecordPageList = (params) => {
	return reqF("post", "/api/sysConfig/Transfer/GetProductTransferRecordPageList", params)
};
// 获取调拨记录详情
export const GetProductTransferRecordDetail = (params) => {
	return reqF("post", "/api/sysConfig/Transfer/GetProductTransferRecordDetail", params)
};
// 删除调拨记录信息
export const DeleteProductTransferRecord = (params) => {
	return reqF("post", "/api/sysConfig/Transfer/DeleteProductTransferRecord", params)
};
// 新增商品调拨记录
export const AddTransferRecord = (params) => {
	return reqF("post", "/api/sysConfig/Transfer/AddTransferRecord", params)
};
// 调拨记录确认
export const ConfirmProductTransferRecord = (params) => {
	return reqF("post", "/api/sysConfig/Transfer/ConfirmProductTransferRecord", params)
};
// 调拨记录接收
export const ReceiveProductTransferRecord = (params) => {
	return reqF("post", "/api/sysConfig/Transfer/ReceiveProductTransferRecord", params)
};
// 获取调拨记录明细分页列表
export const GetProductTransferRecordDtlPageList = (params) => {
	return reqF("post", "/api/sysConfig/Transfer/GetProductTransferRecordDtlPageList", params)
};


// 获取销售订单列表
export const GetSalesOrderPageList = (params) => {
	return reqF("post", "/api/sysConfig/Sales/GetSalesOrderPageList", params)
};
// 保存销售订单
export const SaveSalesOrder = (params) => {
	return reqF("post", "/api/sysConfig/Sales/SaveSalesOrder", params)
};
// 删除销售订单
export const DeleteSalesOrder = (params) => {
	return reqF("post", "/api/sysConfig/Sales/DeleteSalesOrder", params)
};
// 获取销售订单详情
export const GetSalesOrderDetail = (params) => {
	return reqF("post", "/api/sysConfig/Sales/GetSalesOrderDetail", params)
};
// 确认销售订单
export const ConfirmSalesOrder = (params) => {
	return reqF("post", "/api/sysConfig/Sales/ConfirmSalesOrder", params)
};
// 获取确认销售订单详情分页列表
export const GetConfirmSalesOrderDtlList = (params) => {
	return reqF("post", "/api/sysConfig/Sales/GetConfirmSalesOrderDtlList", params)
};
// 获取商品销售明细
export const GetSalesOrderDtlList = (params) => {
	return reqF("post", "/api/sysConfig/Sales/GetSalesOrderDtlList", params)
};
// 支付销售订单欠款
export const PaySalesOrderArrearsMoney = (params) => {
	return reqF("post", "/api/sysConfig/Sales/PaySalesOrderArrearsMoney", params)
};
// 创建销售订单提成
export const CreateSalesOrderCommission = (params) => {
	return reqF("post", "/api/sysConfig/Sales/CreateSalesOrderCommission", params)
};
// 导出销售订单记录
export const ExportSalesOrder = (params) => {
	return reqF("post", "/api/sysConfig/Sales/ExportSalesOrder", params)
};
// 获取门店日统计报表
export const GetStoreDayReport = (params) => {
	return reqF("post", "/api/sysConfig/Sales/GetStoreDayReport", params)
};
// 销售订单退单
export const CancelSalesOrder = (params) => {
	return reqF("post", "/api/sysConfig/Sales/CancelSalesOrder", params)
};
// 门店利润
export const GetStoreProfitReport = (params) => {
	return reqF("post", "/api/sysConfig/Sales/GetStoreProfitReport", params)
};
// 导出门店金额变动明细
export const ExportStoreProfitDtlList = (params) => {
	return reqF("post", "/api/sysConfig/Sales/ExportStoreProfitDtlList", params)
};


// 获取门店库存盘点分页列表
export const GetMonthStoreProductList = (params) => {
	return reqF("post", "/api/sysConfig/Product/GetMonthStoreProductList", params)
};
// 批量创建门店库存盘点
export const BatchCreateMonthStoreProduct = (params) => {
	return reqF("post", "/api/sysConfig/Product/BatchCreateMonthStoreProduct", params)
};
//批量保存真实盘点库存数量
export const BatchSaveRealQty = (params) => {
	return reqF("post", "/api/sysConfig/Product/BatchSaveRealQty", params)
};
//获取门店月盘点库存商品信息列表
export const GetMonthStoreProductExportList = (params) => {
	return reqF("post", "/api/sysConfig/Product/GetMonthStoreProductExportList", params)
};
//导出门店月盘点信息
export const ExportMonthStoreProduct = (params) => {
	return reqF("post", "/api/sysConfig/Product/ExportMonthStoreProduct", params)
};



// 获取门店销售月统计报表
export const GetMonthStoreProductStatistics = (params) => {
	return reqF("post", "/api/sysConfig/Product/GetMonthStoreProductStatistics", params)
};
// 导出门店销售统计报表
export const ExportMonthStoreProductStatistics = (params) => {
	return reqF("post", "/api/sysConfig/Product/ExportMonthStoreProductStatistics", params)
};



// 获取门店申购单分页列表
export const GetStoreSubscriptionPageList = (params) => {
	return reqF("post", "/api/sysConfig/Product/GetStoreSubscriptionPageList", params)
};
//保存门店申购单
export const SaveStoreSubscription = (params) => {
	return reqF("post", "/api/sysConfig/Product/SaveStoreSubscription", params)
};
//获取门店申购单详情
export const GetStoreSubscriptionDetail = (params) => {
	return reqF("post", "/api/sysConfig/Product/GetStoreSubscriptionDetail", params)
};
//删除门店申购单
export const DeleteStoreSubscription = (params) => {
	return reqF("post", "/api/sysConfig/Product/DeleteStoreSubscription", params)
};
//提交门店申购单
export const SubmitStoreSubscription = (params) => {
	return reqF("post", "/api/sysConfig/Product/SubmitStoreSubscription", params)
};
//采购确认
export const ConfirmStoreSubscription = (params) => {
	return reqF("post", "/api/sysConfig/Product/ConfirmStoreSubscription", params)
};
//采购暂存
export const SaveStoreSubscriptionPurchase = (params) => {
	return reqF("post", "/api/sysConfig/Product/SaveStoreSubscriptionPurchase", params)
};
//审核门店申购单
export const AuditStoreSubscription = (params) => {
	return reqF("post", "/api/sysConfig/Product/AuditStoreSubscription", params)
};
//暂存审核门店申购单
export const TempSaveAuditSubScription = (params) => {
	return reqF("post", "/api/sysConfig/Product/TempSaveAuditSubScription", params)
};
//财务付款
export const PayStoreSubScription = (params) => {
	return reqF("post", "/api/sysConfig/Product/PayStoreSubScription", params)
};
//快递单号录入
export const KuaiDiStoreSubScription = (params) => {
	return reqF("post", "/api/sysConfig/Product/KuaiDiStoreSubScription", params)
};
//门店接收
export const ReceiveStoreSubScription = (params) => {
	return reqF("post", "/api/sysConfig/Product/ReceiveStoreSubScription", params)
};
//分页获取申购单明细列表
export const GetStoreSubscriptionDtlPageList = (params) => {
	return reqF("post", "/api/sysConfig/Product/GetStoreSubscriptionDtlPageList", params)
}
//导出申购单明细信息
export const ExportStoreSubscriptionDtl = (params) => {
	return reqF("post", "/api/sysConfig/Product/ExportStoreSubscriptionDtl", params)
}
//申购单明细发快递
export const KuaiDiStoreSubScriptionDtl = (params) => {
	return reqF("post", "/api/sysConfig/Product/KuaiDiStoreSubScriptionDtl", params)
}
//申购单明细付款
export const PayStoreSubScriptionDtl = (params) => {
	return reqF("post", "/api/sysConfig/Product/PayStoreSubScriptionDtl", params)
}


//申购单退货
export const StoreSubscriptionReturn = (params) => {
	return reqF("post", "/api/sysConfig/Product/StoreSubscriptionReturn", params)
};
//分页获取申购单退货明细信息
export const GetStoreSubscriptionReturnageList = (params) => {
	return reqF("post", "/api/sysConfig/Product/GetStoreSubscriptionReturnageList", params)
}
//门店发送快递退货
export const StoreSendKuaiDi = (params) => {
	return reqF("post", "/api/sysConfig/Product/StoreSendKuaiDi", params)
}
//采购部换货
export const PurchaseExchange = (params) => {
	return reqF("post", "/api/sysConfig/Product/PurchaseExchange", params)
}
//采购部发送快递
export const PurchaseSendKuaiDi = (params) => {
	return reqF("post", "/api/sysConfig/Product/PurchaseSendKuaiDi", params)
}
//门店接收换货
export const StoreReceiveProduct = (params) => {
	return reqF("post", "/api/sysConfig/Product/StoreReceiveProduct", params)
}

